<mat-card-content>
    <div class="table-wrapper">
        <table mat-table [dataSource]="effectiveDatasource" matSort [matSortDisabled]="!isSortable" (matSortChange)="onSortChanged($event)" cdkDropList  [cdkDropListData]="dataSource.data || dataSource" (cdkDropListDropped)="onRowDrop($event)" [cdkDropListDisabled]="isDragDisabled" class="mat-elevation-z8 full-width-table">
            <!-- Colonne dinamiche (tutte tranne 'actions') -->
            @for (col of displayedColumns; track col) { @if (col !== 'actions' && col !== 'shift') {
            <ng-container [matColumnDef]="col">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="{{ col }}">
                    {{ columnLabels[col] || col }}
                </th>

                <td mat-cell *matCellDef="let element" [ngClass]="{'inactive-cell': (nameTable === 'crawling-web' && element.state === false) || nameTable === 'draft'}">
                    @if (col === 'enabled') {
                    <mat-icon [class.enabled-true]="element?.enabled">
                        {{ element?.enabled ? 'check' : 'close' }}
                    </mat-icon>
                    } @else if (col === 'status' && nameTable === 'crawling-web') {
                    <span class="status-cell">
                  <span
                    class="status-dot"
                    [ngClass]="{
                      'pending': isJobPendingFn(element.id),
                      'running': !isJobPendingFn(element.id) && element.status === 'RUNNING',
                      'finished': !isJobPendingFn(element.id) && element.status === 'FINISHED',
                      'scheduled': !isJobPendingFn(element.id) && element.status === 'SCHEDULED',
                      'killed': !isJobPendingFn(element.id) && element.status === 'KILLED',
                      'failed': !isJobPendingFn(element.id) && element.status === 'FAILED',
                      'paused': !isJobPendingFn(element.id) && element.status === 'PAUSED',
                      'other':
                        !isJobPendingFn(element.id) &&
                        element.status !== 'FAILED' &&
                        element.status !== 'KILLED' &&
                        element.status !== 'SCHEDULED' &&
                        element.status !== 'FINISHED' &&
                        element.status !== 'RUNNING' &&
                        element.status !== 'PAUSED'
                    }"
                  ></span>
                    <span *ngIf="isJobPendingFn(element.id)" class="status-pending">
                    PENDING
                  </span>
                    <span *ngIf="!isJobPendingFn(element.id)">
                    {{ element[col] }}
                  </span>
                    </span>
                    } @else if (col === 'status' && nameTable === 'draft'){
                      <span class="status-cell">
                  <span
                    class="status-dot"
                    [ngClass]="{
                      'draft': element.status === 'DRAFT'
                    }"
                  ></span>
                  {{ element[col] }}
                  </span>
                    } @else if ((col === 'updatedDate' && nameTable === 'JSON-XML-logs') || (col === 'date' && nameTable === 'Kentico-logs')) {
                       {{formatDate(element[col])}}
                    } @else if (col === 'dimension' && nameTable === 'JSON-XML-logs') {
                      {{bytesToKB(element[col])}} KB
                    } @else if(col === 'message' && nameTable === 'Kentico-logs'){
                      <div class="prelike" [class.clamped]="!isExpanded(element)">{{isExpanded(element) || element[col]?.length <= 20 ? element[col] : (element[col] | slice:0:20) + '...'}}</div>
                        @if(element[col] && element[col].length > 20){
                          <button mat-button type="button" color="primary" class="toggle" (click)="toggleExpand(element, $event)">
                            {{isExpanded(element) ? 'Mostra meno' : 'Mostra tutto'}}
                          </button>
                        }
                    }
                    @else { {{ element[col] }} }
                </td>
            </ng-container>
            } }

            <!-- Colonna ACTIONS -->
            @if (displayedColumns?.includes('actions')) {
            <ng-container matColumnDef="actions">
                <!-- Header cell: toolbar -->
                <th mat-header-cell *matHeaderCellDef class="mat-column-actions">
                    <div class="table-toolbar">
                        <!-- Toolbar speciale per Crawling Web -->
                        @if (nameTable === 'crawling-web') {
                        <button type="button" class="btn btn-outlined-primary refresh-button" [disabled]="!canDoActions('BACKOFFICE_ADMIN')" (click)="emitToolbarAction('refresh')" aria-label="Refresh" title="Refresh">
                  <mat-icon>refresh</mat-icon>
                  Refresh
                </button>

                        <button type="button" class="btn btn-outlined-primary stop-all-button" [disabled]="isAnyJobPendingFn() || !canDoActions('BACKOFFICE_ADMIN')" (click)="emitToolbarAction('stopAll')" aria-label="Stop All" title="Stop All">
                  <ng-container *ngIf="!isAnyJobPendingFn(); else stopAllLoading">
                    <mat-icon>stop</mat-icon>
                  </ng-container>
                  <ng-template #stopAllLoading>
                    <mat-progress-spinner
                      diameter="20"
                      mode="indeterminate"
                    ></mat-progress-spinner>
                  </ng-template>
                  Stop All
                </button> }
                <!-- Toolbar speciale per Keymatch -->
                @else if (nameTable === 'keymatch'){
                  <button type="button" class="btn btn-outlined-primary export-button" [disabled]="!canDoActions('BACKOFFICE_ADMIN')" (click)="emitToolbarAction('export')" aria-label="Export" title="Export">
                  <mat-icon>download</mat-icon>
                  Esporta
                </button>
                <button type="button" class="btn btn-outlined-primary import-button" [disabled]="!canDoActions('BACKOFFICE_ADMIN')" (click)="emitToolbarAction('import')" aria-label="Import" title="Import">
                  <mat-icon>upload</mat-icon>
                  Importa
                </button>
                }
              <!-- Toolbar speciale tabella di dettaglio degli url nella sezione crawling web -->
                @else if (nameTable === 'crawling-web-urls-detail'){
                  <button type="button" class="btn btn-outlined-primary export-button" [disabled]="!canDoActions('BACKOFFICE_ADMIN')" (click)="emitToolbarAction('export')" aria-label="Export" matTooltip="Export">
                  <mat-icon>download</mat-icon>
                  Esporta
                </button>
                }

                <!-- Logica Add -->
                @if (nameTable === 'suggestions') {
                  <!-- Suggestions: Aggiungi un termine da escludere -->
                  <button type="button" class="btn-primary add-button" [disabled]="!canDoActions('BACKOFFICE_ADMIN')" (click)="requestOpenDialog({}, 'add')" aria-label="Escludi un termine" title="Escludi un termine">
                    <mat-icon>remove_circle_outline</mat-icon>
                    Escludi
                  </button>
                } @else {
                   <!-- Default: Aggiungi un elemento (in base ai permessi) -->
                  <button type="button" class="btn-primary add-button" *ngIf="!notAllowAdd" [disabled]="!canDoActions('BACKOFFICE_ADMIN')" (click)="requestOpenDialog({}, 'add', nameTable!)" aria-label="Aggiungi elemento" title="Aggiungi">
                    <mat-icon>add</mat-icon>
                    Aggiungi
                  </button>
                }  
                  </div>
                </th>

                <!-- Celle riga: azioni -->
                <td mat-cell *matCellDef="let element" class="mat-column-actions">
                  <!-- Gestione crawling (monitoring)/Impostazioni Query → pulsante DOWNLOAD -->
                    @if (nameTable === 'JSON-XML-logs' || nameTable === 'synonyms' || nameTable === 'keywordsToIgnore' || nameTable === 'keywordsNotExpand') {
                      <button mat-icon-button type="button" [disabled]="!canDoActions('BACKOFFICE_ADMIN')" (click)="emitDownloadAction(element)" aria-label="Download" title="Download">
                      <mat-icon>download</mat-icon>
                      </button>
                    }
                    <!-- Crawling Web -->
                    @if (nameTable === 'crawling-web') { 
                      @if(element.state){
                        <button mat-icon-button type="button" class="icon-busy" (click)="toggleActivationJob(element, 'deactivate'); $event.stopPropagation()" [disabled]="!canDoActions('BACKOFFICE_ADMIN')" aria-label="Disattiva runnable job" title="Disattiva runnable job">
                        <mat-icon>event_busy</mat-icon></button>
                      } @if(!element.state){
                          <button mat-icon-button type="button" class="icon-available" (click)="toggleActivationJob(element, 'activate'); $event.stopPropagation()" [disabled]="!canDoActions('BACKOFFICE_ADMIN')" aria-label="Attiva runnable job" title="Attiva runnable job">
                          <mat-icon>event_available</mat-icon></button>
                        }
                      @if (allowedStatusPlayIcon.includes(element?.status)) {
                    <button mat-icon-button type="button" [disabled]="isJobPendingFn(element.id) || !canDoActions('BACKOFFICE_ADMIN') || !element.state" (click)="requestJobAction(element, 'start'); $event.stopPropagation()" aria-label="Avvia job" title="Avvia job">
                  <ng-container *ngIf="!isJobPendingFn(element.id); else playLoading">
                    <mat-icon>play_arrow</mat-icon>
                  </ng-container>
                  <ng-template #playLoading>
                    <mat-progress-spinner
                      diameter="20"
                      mode="indeterminate"
                    ></mat-progress-spinner>
                  </ng-template>
                </button> } @if (allowedStatusStopIcon.includes(element?.status)) {
                    <button mat-icon-button type="button" [disabled]="isJobPendingFn(element.id) || !canDoActions('BACKOFFICE_ADMIN')" (click)="requestJobAction(element, 'stop'); $event.stopPropagation()" aria-label="Stop job" title="Stop job">
                  <ng-container *ngIf="!isJobPendingFn(element.id); else stopLoading">
                    <mat-icon>stop</mat-icon>
                  </ng-container>
                  <ng-template #stopLoading>
                    <mat-progress-spinner
                      diameter="20"
                      mode="indeterminate"
                    ></mat-progress-spinner>
                  </ng-template>
                </button> }
                    <button mat-icon-button type="button" (click)="requestOpenDialog(element, 'delete'); $event.stopPropagation()" [disabled]="isJobPendingFn(element.id) || shouldDisableActionsOnRowFn(element) || !canDoActions('BACKOFFICE_ADMIN')" aria-label="Elimina runnable job" title="Elimina runnable job">
                <mat-icon>delete</mat-icon>
              </button> } @else if (nameTable === 'draft') {
                <button mat-icon-button type="button" class="icon-schedule" (click)="goToSchedule(element)" [disabled]="!canDoActions('BACKOFFICE_ADMIN')" aria-label="Aggiungi una schedulazione al draft job" title="Aggiungi una schedulazione al draft job">
                <mat-icon>schedule</mat-icon></button>
                <button mat-icon-button type="button" (click)="requestOpenDialog(element, 'delete'); $event.stopPropagation()" [disabled]="!canDoActions('BACKOFFICE_ADMIN')" aria-label="Elimina draft job" title="Elimina draft job">
                <mat-icon>delete</mat-icon></button>
              } 
              @else if (nameTable === 'diagnostics') {
                    <!-- Diagnostics → pulsante COPIA URL -->
                    <button mat-icon-button type="button" (click)="copyUrl(element?.url); $event.stopPropagation()" [disabled]="!element?.url || !canDoActions('BACKOFFICE_ADMIN')" aria-label="Copia URL" title="Copia URL">
                <mat-icon>content_copy</mat-icon>
              </button> }
               @else {
                    <!-- Default: Edit/Delete in base ai permessi -->
                    <button mat-icon-button type="button" *ngIf="!notAllowEdit && !element?.system" [disabled]="!canDoActions('BACKOFFICE_ADMIN')" (click)="requestOpenDialog(element, 'edit', nameTable!); $event.stopPropagation()" aria-label="Modifica elemento" title="Modifica">
                <mat-icon>edit</mat-icon>
              </button>

              <span [matTooltip]="(nameTable === 'crawling-web-urls-detail' && length === 1) || (nameTable === 'crawling-web-schedules-detail' && length === 1)  ? 'Il job schedule non può rimanere senza elementi in questa tabella.' : null" matTooltipClass="custom-tooltip">
                <button mat-icon-button type="button" *ngIf="!notAllowDelete && !element?.system" [disabled]="!canDoActions('BACKOFFICE_ADMIN') || (nameTable === 'crawling-web-urls-detail' && length === 1) || (nameTable === 'crawling-web-schedules-detail' && length === 1)" (click)="requestOpenDialog(element, 'delete'); $event.stopPropagation()" aria-label="Elimina elemento" title="Elimina">
                  <mat-icon>delete</mat-icon>
                </button>
              </span>      
               }
                </td>
            </ng-container>
            }

            <!-- Colonna spanning per gestione loading, error ed empty table -->
            <ng-container matColumnDef="spanning">
              <td mat-cell *matCellDef="let row" [attr.colspan]="displayedColumns.length">
                @if(isLoading) {
                  <div class="loading-container">
                    <mat-progress-spinner mode="indeterminate" diameter="30"></mat-progress-spinner>
                  </div>
                } @else if(hasError){
                  <div class="error-container">
                    Si è verificato un errore nel recupero dei dati. Riprovare più tardi.
                  </div>
                } @else {
                  <div class="empty-container">
                    Non sono ancora presenti elementi
                  </div>
                }
              </td>

            </ng-container>

            <!-- Colonna SHIFT -->
            
              <ng-container matColumnDef="shift">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let row" class="mat-column-shift">
                  <button mat-icon-button cdkDragHandle [disabled]="isDragDisabled">
                    <mat-icon>drag_indicator</mat-icon>
                  </button>
                </td>

              </ng-container>
             
              

            <!-- Header / Rows -->
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

            <tr mat-row *matRowDef="let row; columns: displayedColumns" cdkDrag [cdkDragData]="row" [cdkDragDisabled]="isDragDisabled" [class.clickable-row]="enableRowClick" [ngClass]="{'inactive-job': (nameTable === 'crawling-web' && row.state === false) || nameTable === 'draft', 'no-pointer': nameTable === 'draft'}" (click)="onRowClick(row, $event)" tabindex="0" role="button" (keydown)="onRowKeydown(row, $event)">
              <div *cdkDragPreview class="custom-drag-preview">{{row.label || 'Spostamento in corso...'}}</div>
            </tr>

            <!-- Casistica Loading, Empty o Error -->
            <tr mat-row *matRowDef="let row; columns: ['spanning']; when: isSpanningRow"></tr>
             
        </table>

        <!-- Paginatore -->
        <mat-paginator [length]="length" [pageSize]="pageSize" [pageIndex]="pageIndex" [pageSizeOptions]="[5, 10, 25, 50]" (page)="onPageEvent($event)">
        </mat-paginator>
    </div>
</mat-card-content>